enum PlanRecurringInterval {
    YEAR = 'year',
    MONTH = 'month',
    WEEK = 'week',
    DAY = 'day',
}

export default PlanRecurringInterval;
